import React from 'react'
import { Link, Redirect } from 'react-router-dom'

import { connect } from 'react-redux'
import { firebaseConnect } from 'react-redux-firebase'
import { compose } from 'redux'
import { getUsers } from 'store/actions/userActions'
import UserSummary from './UserSummary'
import Fab from '@material-ui/core/Fab';


const floatingStyle = {
  margin: 0,
  top: 'auto',
  right: 20,
  bottom: 20,
  left: 'auto',
  position: 'fixed',
  background: '#00acc1',
  color: '#ffffff',
  zIndex: 1
};

class UserList extends React.Component {
  
  constructor(props) {
    super(props);
  }

  invite = () => {
    this.props.history.push('/invite');
  }

  render() {
    const { users, auth, selectedProject } = this.props;
    if (!auth.uid) return <Redirect to='/signin' /> 

    if ((users === null || users === undefined) && (selectedProject !== null && selectedProject !== undefined)) {
      this.props.getUsers(selectedProject.companyName, selectedProject.projectName);
    }

   return (
    <div className="user-list center section" style={{display: "flex", flexDirection: "column"}}>
     <Link to={"/invite/" + selectedProject.companyName + "/" + selectedProject.projectName}><Fab color={"inherit"} className="left" style={floatingStyle}>
              Invite
      </Fab>
      </Link>
      { users && users.map(user => {
        return (
            <UserSummary user={user}/>
            
           
          
        )
      })
        
      }  
      
    </div>
  )
  }
}

const mapDispatchToProps = dispatch => {
    return {
      
          
          getUsers: (companyName, projectName) => dispatch(getUsers(companyName, projectName))
          
    }
  }
  
  
const mapStateToProps = (state) => {
    console.log(state);
    const users = state.user.users;
    return {
      auth: state.firebase.auth,
      users: users,
      selectedProject: state.project.selectedProject
    }
  }
  
  export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    firebaseConnect([
      'tapes'
    ])
  )(UserList)




// WEBPACK FOOTER //
// ./src/components/users/UserList.js